import { useAuthStore } from '@stores/authStore';
import { getRoleDisplayName } from '@/types/staff';

export const Profile = () => {
  const { user } = useAuthStore();

  if (!user) return null;

  return (
    <div>
      <h2>Profile Settings</h2>
      <p className="text-secondary">Manage your account information</p>

      <div className="info-card" style={{ marginTop: 'var(--spacing-xl)', maxWidth: '600px' }}>
        <h3 className="info-card-title">Personal Information</h3>
        
        <div className="info-grid">
          <div className="info-item">
            <span className="info-label">Name</span>
            <span className="info-value">{user.first_name} {user.last_name}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Email</span>
            <span className="info-value">{user.email}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Phone</span>
            <span className="info-value">{user.phone_number || 'Not set'}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Role</span>
            <span className="info-value">{getRoleDisplayName(user.role)}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Last Login</span>
            <span className="info-value">
              {user.last_login_at ? new Date(user.last_login_at).toLocaleString() : 'Never'}
            </span>
          </div>
        </div>

        <div style={{ marginTop: 'var(--spacing-xl)', display: 'flex', gap: 'var(--spacing-md)' }}>
          <button className="btn btn-secondary">Edit Profile</button>
          <button className="btn btn-ghost">Change Password</button>
        </div>
      </div>
    </div>
  );
};

